import { createSelector } from 'reselect';

import { providerNames } from 'resources/ethereum/providers';
import { selectWeb3LibLoadState } from 'store/libs/selectors';
import { selectCurrentUserEthereumAddress } from 'store/features/auth/selectors';

export const selectEthereumFeatureState = state => state.features.ethereum;

export const selectEthereumBasicInfoState = createSelector(
  selectEthereumFeatureState,
  featureState => featureState.basicInfo
);

export const selectDetectedEthereumProviderName = createSelector(
  selectEthereumBasicInfoState,
  ethereum => ethereum.providerName
);

export const selectDetectedEthereumNetworkName = createSelector(
  selectEthereumBasicInfoState,
  ethereum => ethereum.networkName
);

export const selectEthereumAccountAddresses = createSelector(
  selectEthereumBasicInfoState,
  ethereum => ethereum.accounts
);

export const selectCurrentEthereumAccountAddress = createSelector(
  selectEthereumBasicInfoState,
  ethereum => ethereum.currentAccount
);

export const selectMedianGasPriceInGwei = createSelector(
  selectEthereumBasicInfoState,
  ethereum => ethereum.medianGasPriceInGwei
);

const requiredNetworkName = process.env.REACT_APP_SC_NETWORK;

export const METAMASK_STATUSES = {
  notInstalled: 'not-installed',
  installedButWrongNetwork: 'installed-but-wrong-network',
  installedButLocked: 'installed-but-locked',
  installedButUserHasNoEthereumAddress: 'installed-but-user-has-no-ethereum-address',
  installedButWrongAccountAddress: 'installed-but-wrong-account-address',
  connected: 'connected',
};

export const selectMetaMaskStatus = createSelector(
  selectWeb3LibLoadState,
  selectDetectedEthereumProviderName,
  selectDetectedEthereumNetworkName,
  selectCurrentEthereumAccountAddress,
  selectCurrentUserEthereumAddress,
  (web3LoadState, provider, network, currentAccountAddress, currentUserEthereumAddress) => {
    if (!web3LoadState.loaded || provider !== providerNames.metaMask)
      return METAMASK_STATUSES.notInstalled;
    if (network !== requiredNetworkName) return METAMASK_STATUSES.installedButWrongNetwork;
    if (!currentAccountAddress) return METAMASK_STATUSES.installedButLocked;
    if (!currentUserEthereumAddress) return METAMASK_STATUSES.installedButUserHasNoEthereumAddress;
    if (currentUserEthereumAddress.toUpperCase() !== currentAccountAddress.toUpperCase())
      return METAMASK_STATUSES.installedButWrongAccountAddress;
    return METAMASK_STATUSES.connected;
  }
);
